import { render, staticRenderFns } from "./SubscriptionOfferDetails.vue?vue&type=template&id=660fb5f8&"
import script from "./SubscriptionOfferDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriptionOfferDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports